<template>
    <span>
        <template v-if="displayType === 'table'">
            <record-list-table-frontend :records="filteredLocations" 
                :record-fields-to-display="fieldsToDisplay"
                :record-detail-fields-to-display="detailFieldsToDisplay"
                :show-private-type="showPrivateCharterDocuments !== null ? showPrivateCharterDocuments : true"
                :show-royal-type="showRoyalCharterDocuments !== null ? showRoyalCharterDocuments : true"
                :show-place-of-writing="showPlaceOfWritingDocuments !== null ? showPlaceOfWritingDocuments : true"
                :show-place-of-goods="showPlaceOfGoodsDocuments !== null ? showPlaceOfGoodsDocuments : true"
                :show-mentioned-place="showMentionedPlaceDocuments !== null ? showMentionedPlaceDocuments : true"
                :show-only-exhibited="showOnlyExhibited !== null ? showOnlyExhibited : false">
            </record-list-table-frontend>
        </template>

        <template v-else-if="displayType === 'accordion'">
            <locations-accordion :locations="filteredLocations"
                :show-private-type="showPrivateCharterDocuments !== null ? showPrivateCharterDocuments : true"
                :show-royal-type="showRoyalCharterDocuments !== null ? showRoyalCharterDocuments : true"
                :show-place-of-writing="showPlaceOfWritingDocuments !== null ? showPlaceOfWritingDocuments : true"
                :show-place-of-goods="showPlaceOfGoodsDocuments !== null ? showPlaceOfGoodsDocuments : true"
                :show-mentioned-place="showMentionedPlaceDocuments !== null ? showMentionedPlaceDocuments : true"
                :show-only-exhibited="showOnlyExhibited !== null ? showOnlyExhibited : false">
            </locations-accordion>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            locations: { type: Array, required: true },
            fieldsToDisplay: { type: Array, required: false },
            detailFieldsToDisplay: { type: Array, required: false },
            displayType: { type: String, required: false, default: 'table'}
        },

        data() {
            return {
                filteredLocations: this.locations,
                leadingCharacterFilterValue: '',
                dateRangeFilterValue: null,
                checkBoxGroupFilter: null,
                dropdownFilter: null,
                locationsFilter: null,
                showPlaceOfWritingDocuments: null,
                showPlaceOfGoodsDocuments: null,
                showMentionedPlaceDocuments: null,
                showPrivateCharterDocuments: null, 
                showRoyalCharterDocuments: null,
                showOnlyExhibited: null
            }
        },

        created() {
            EventDispatcher.listen('resetFilters', () => {
                this.filteredLocations = this.locations;
                this.leadingCharacterFilterValue = '';
                this.dateRangeFilterValue = null;
                this.checkBoxGroupFilter = null;
                this.dropdownFilter = null;
                this.locationsFilter = null;
                this.showPlaceOfWritingDocuments = null,
                this.showPlaceOfGoodsDocuments = null,
                this.showMentionedPlaceDocuments =  null,
                this.showPrivateCharterDocuments = null, 
                this.showRoyalCharterDocuments = null,
                this.showOnlyExhibited = null
                
            });

            EventDispatcher.listen('locationFilterApplied', (locationName) => {
                // save the value of the most recent location filter
                this.locationsFilter = locationName;

                var locationsToFilter = this.locations;
                
                // apply the location filter
                locationsToFilter = this.applyLocationFilter(locationsToFilter, locationName);
                
                // apply the leading character filter
                locationsToFilter = this.applyLeadingCharacterFilter(locationsToFilter, this.leadingCharacterFilterValue);

                // apply the checkbox group filter
                locationsToFilter = this.applyCheckBoxGroupFilter(locationsToFilter, this.checkBoxGroupFilter);

                // apply dropdown filter
                locationsToFilter = this.applydropdownFilter(locationsToFilter, this.dropdownFilter);

                // apply the date range filter
                locationsToFilter = this.applyDateRangeFilter(locationsToFilter, this.dateRangeFilterValue);
                
                this.filteredLocations = locationsToFilter;
                EventDispatcher.fire('locationRecordsUpdated', this.filteredLocations);
            });

            EventDispatcher.listen('startsWithFilterApplied', (char) => {
                // save the value of the most recent leading character filter
                this.leadingCharacterFilterValue = char;

                var locationsToFilter = this.locations;

                // apply the leading character filter
                locationsToFilter = this.applyLeadingCharacterFilter(locationsToFilter, this.leadingCharacterFilterValue);

                // apply the checkbox group filter
                locationsToFilter = this.applyCheckBoxGroupFilter(locationsToFilter, this.checkBoxGroupFilter);

                // apply dropdown filter
                locationsToFilter = this.applydropdownFilter(locationsToFilter, this.dropdownFilter);

                // apply the date range filter
                locationsToFilter = this.applyDateRangeFilter(locationsToFilter, this.dateRangeFilterValue);

                // apply the location filter
                locationsToFilter = this.applyLocationFilter(locationsToFilter, this.locationsFilter);

                this.filteredLocations = locationsToFilter;
            });

            EventDispatcher.listen('checkBoxGroupFiltersApplied', (checkBoxGroupFilter) => {
                // save the value of the most recent checkbox group filter
                this.checkBoxGroupFilter = checkBoxGroupFilter;

                var locationsToFilter = this.locations;

                // apply the leading character filter
                locationsToFilter = this.applyLeadingCharacterFilter(locationsToFilter, this.leadingCharacterFilterValue);

                // apply the date range filter
                locationsToFilter = this.applyDateRangeFilter(locationsToFilter, this.dateRangeFilterValue);

                // apply checkbox filter
                locationsToFilter = this.applyCheckBoxGroupFilter(locationsToFilter, checkBoxGroupFilter);

                // apply dropdown filter
                locationsToFilter = this.applydropdownFilter(locationsToFilter, this.dropdownFilter);

                // apply the location filter
                locationsToFilter = this.applyLocationFilter(locationsToFilter, this.locationsFilter);

                this.filteredLocations = locationsToFilter;
                EventDispatcher.fire('locationRecordsUpdated', this.filteredLocations);
            });

            EventDispatcher.listen('dropdownFiltersApplied', (dropdownFilter) => {
                // save the value of the most recent checkbox group filter
                this.dropdownFilter = dropdownFilter;

                var locationsToFilter = this.locations;

                // apply the leading character filter
                locationsToFilter = this.applyLeadingCharacterFilter(locationsToFilter, this.leadingCharacterFilterValue);

                // apply the date range filter
                locationsToFilter = this.applyDateRangeFilter(locationsToFilter, this.dateRangeFilterValue);

                // apply checkbox filter
                locationsToFilter = this.applyCheckBoxGroupFilter(locationsToFilter, this.checkBoxGroupFilter);

                // apply dropdown filter
                locationsToFilter = this.applydropdownFilter(locationsToFilter, dropdownFilter);

                // apply the location filter
                locationsToFilter = this.applyLocationFilter(locationsToFilter, this.locationsFilter);

                this.filteredLocations = locationsToFilter;
            });

            EventDispatcher.listen('dateRangeValueChanged', (dateRange) => {
                // save the value of the most recent date range filter
                this.dateRangeFilterValue = dateRange;

                var locationsToFilter = this.locations;

                // apply the leading character filter
                locationsToFilter = this.applyLeadingCharacterFilter(locationsToFilter, this.leadingCharacterFilterValue);

                // apply the checkbox group filter
                locationsToFilter = this.applyCheckBoxGroupFilter(locationsToFilter, this.checkBoxGroupFilter);

                // apply the date range filter
                locationsToFilter = this.applyDateRangeFilter(locationsToFilter, this.dateRangeFilterValue);

                // apply dropdown filter
                locationsToFilter = this.applydropdownFilter(locationsToFilter, this.dropdownFilter);

                // apply the location filter
                locationsToFilter = this.applyLocationFilter(locationsToFilter, this.locationsFilter);

                this.filteredLocations = locationsToFilter;
            });
        },

        mounted() {
            EventDispatcher.fire('locationRecordsUpdated', this.filteredLocations);
        },

        methods: {
            applyLocationFilter(locations, locationName) {
                var locationsToFilter = locations;
                if (this.locationsFilter && locationName !== '') {
                    locationsToFilter = locationsToFilter.filter(location => location.display_name == locationName);
                }
                return locationsToFilter;
            },
            applyLeadingCharacterFilter(locations, leadingCharacterFilterValue) {
                var locationsToFilter = locations;
                if (leadingCharacterFilterValue !== '') {
                    locationsToFilter = locationsToFilter.filter(location => location.display_name.startsWith(leadingCharacterFilterValue));
                }
                return locationsToFilter;
            },
            applyCheckBoxGroupFilter(locations, checkBoxGroup) {
                var locationsToFilter = locations;
                let bHasPlaceOfWritingChecked = false; 
                let bHasPlaceOfGoodsChecked = false;
                let bHasMentionedPlaceChecked = false;
                let bHasPrivateCharterChecked = false; 
                let bHasRoyalCharterChecked = false;
                
                if(checkBoxGroup) {
                    let checkedLocationTypes = [];
                    let checkedCharterTypes = [];
                    this.showPrivateCharterDocuments = false;
                    this.showRoyalCharterDocuments = false;
                    this.showPlaceOfWritingDocuments = false;
                    this.showPlaceOfGoodsDocuments = false;
                    this.showMentionedPlaceDocuments = false;
                    this.showOnlyExhibited = false;
                    let _this = this;
                    checkBoxGroup.forEach(function(checkbox, index) {
                        if(checkbox.name == 'currently_on_display' && checkbox.checked) {
                            // only show exhibited charters
                            locationsToFilter = locationsToFilter.filter(location => location.has_exhibited_charter);
                            _this.showOnlyExhibited = true;
                        }

                        if(checkbox.name == 'place_of_writing' && checkbox.checked) {
                            checkedLocationTypes.push('has_place_of_writing');
                            bHasPlaceOfWritingChecked = true;
                            _this.showPlaceOfWritingDocuments = true;
                        }
                        if(checkbox.name == 'place_of_goods' && checkbox.checked) {
                            checkedLocationTypes.push('has_place_of_goods');
                            bHasPlaceOfGoodsChecked = true;
                            _this.showPlaceOfGoodsDocuments = true;
                        }
                        if(checkbox.name == 'mentioned_place' && checkbox.checked) {
                            checkedLocationTypes.push('has_mentioned_place');
                            bHasMentionedPlaceChecked = true;
                            _this.showMentionedPlaceDocuments = true;
                        }

                        if(checkbox.name == 'privaturkunde' && checkbox.checked) {
                            // do not show private charters
                            //locationsToFilter = locationsToFilter.filter(location => !location.has_private_charter);
                            checkedCharterTypes.push('has_private_charter');
                            bHasPrivateCharterChecked = true;
                            _this.showPrivateCharterDocuments = true;
                        }
                        if(checkbox.name == 'herrscherurkunde' && checkbox.checked) {
                            // do not show royal charters
                            //locationsToFilter = locationsToFilter.filter(location => !location.has_royal_charter);
                            checkedCharterTypes.push('has_royal_charter');
                            bHasRoyalCharterChecked = true;
                            _this.showRoyalCharterDocuments = true;
                        }

                    });

                    // filter by type of charter
                    // no charter type was selected => show no records
                    if(checkedCharterTypes.length == 0) {
                        locationsToFilter = [];
                    } else { 
                        locationsToFilter = locationsToFilter.filter(function(location) {
                            return (bHasPrivateCharterChecked && location.has_private_charter == 1)
                                    || (bHasRoyalCharterChecked && location.has_royal_charter == 1);

                        });
                    }

                    // filter by type of location
                    // no location type was selected => show no records
                    if(checkedLocationTypes.length == 0) {
                        locationsToFilter = [];
                    } else { 
                        locationsToFilter = locationsToFilter.filter(function(location) {
                            return (bHasPlaceOfWritingChecked && location.has_place_of_writing_charter == 1)
                                    || (bHasPlaceOfGoodsChecked && location.has_place_of_goods_charter == 1)
                                    || (bHasMentionedPlaceChecked && location.has_mentioned_place_charter == 1);

                        });
                    }
                } 
                return locationsToFilter;
            },

            applyDateRangeFilter(locations, dateRangeFilterValue) {
                var locationsToFilter = locations;
                if (dateRangeFilterValue) {
                    locationsToFilter = locationsToFilter.filter(location => 
                        (location.earliest_charter_year >= dateRangeFilterValue.start && location.earliest_charter_year <= dateRangeFilterValue.end) ||
                        (location.latest_charter_year >= dateRangeFilterValue.start && location.latest_charter_year <= dateRangeFilterValue.end));
                }
                return locationsToFilter;
            },
             applydropdownFilter(locations, dropdownFilter) {
                var locationsToFilter = locations;
                if (dropdownFilter && dropdownFilter.value !== '#') {
                    locationsToFilter = locationsToFilter.filter(function(location) {
                       let topicIds = JSON.parse(location.topic_ids)
                       return topicIds && Object.values(topicIds).indexOf(dropdownFilter.value )!= -1;
                    });
                }
                return locationsToFilter;
            }

        }
    }
</script>